module.exports = __webpack_public_path__ + "static/media/S1N7.8bcc5a37.svg";